<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { handleTokenExpire } from "@/helpers/main";
import { sendUserInformationToAmplitude } from "@/mixins/common";
import { localStorageKeys } from "@/enums/common";

export default {
  name: "app",
  mixins: [ sendUserInformationToAmplitude ],
  data() {
    return {
      publicRoutes: [ "public-insight-post" ],
      exceptionRouteNames: [
        "public-insight-post",
        "signup",
        "login",
        "appsumoLogin",
        "paymentSuccess",
        "shopifyLogin",
        "explore-packages",
        "maintenance"
      ],
      tokenStatusInterval: undefined,
      intervalMilliSeconds: 30000,
    };
  },
  computed: {
    routeName() {
      return this.$route.name;
    },
    ...mapGetters('auth', [
      'getUserInformation',
      'getUserPremiumPlanInformation',
    ]),
    ...mapGetters('common', [ 'getApisLoadStates','getActiveClientID','getLocalStorageValueByKey' ]),
    triggerAmplitudeUserEvents() {
      if (!Object.keys(this.getUserInformation).length) return;

      if (this.getUserInformation.isOnboardingCompleted){
        return this.getApisLoadStates.clients?.isLoaded && this.getActiveClientID;
      }

      if (this.getLocalStorageValueByKey(localStorageKeys.newSession)){
        return true;
      }
    }
  },
  watch: {
    triggerAmplitudeUserEvents: {
      handler(newVal) {
        if (!newVal) return;

        this.sendUserInformationToAmplitude();
      },
      immediate: true
    }
  },
  created() {
    this.startGTM();
    this.startFullStory();
    this.startUserTokenStatusCheck();
  },
  mounted() {
    this.amplitudeSetUser();
    this.startHelpCrunch();
  },
  methods: {
    startUserTokenStatusCheck() {
      if (this.exceptionRouteNames.includes(this.routeName)) return;

      this.tokenStatusInterval = setInterval(this.checkTokenStatus, this.intervalMilliSeconds);
    },
    async checkTokenStatus() {
      if (this.exceptionRouteNames.includes(this.routeName)) {

        clearInterval(this.tokenStatusInterval)

        return;
      }
      await handleTokenExpire();

      if (this.getLocalStorageValueByKey(localStorageKeys.jwt)) return;

      this.$router.push({ "name": "logout" });
    },
    amplitudeSetUser() {
      if (amplitude.getInstance()._newSession) {
        amplitude.getInstance().logEvent("session_start", {
          sessionStatus: "Start",
        });
      }
    },
    startHelpCrunch() {
      window.HelpCrunch("init", "heybooster", {
        applicationId: process.env.HELPCRUNCH_APP_ID,
        applicationSecret: process.env.HELPCRUNCH_SECRET_KEY,
        user: {
          email: this.getUserInformation.email,
          name: this.getUserInformation.fullName,
          user_id: this.getUserInformation.email,
          user_created_at: parseInt(this.getUserInformation.creationTimeStamp),
          premium: this.getUserPremiumPlanInformation.status
        }
      });

      HelpCrunch("showChatWidget");
    },
    startGTM(){
      !function (e, a, t, r) {
        e[r] = e[r] || [], e[r].push({
          "gtm.start": (new Date).getTime(),
          event: "gtm.js"
        }), r = a.getElementsByTagName(t)[0], (t = a.createElement(t)).async = !0, t.src = "https://www.googletagmanager.com/gtm.js?id=GTM-MHJFMPB", r.parentNode.insertBefore(t, r)
      }(window, document, "script", "dataLayer");
      var dataLayer = dataLayer || [];
      dataLayer.push({ userid: this.getUserInformation.email });
    },
    startFullStory() {
      window._fs_debug = !1, window._fs_host = "fullstory.com", window._fs_script = "edge.fullstory.com/s/fs.js", window._fs_org = "VTCHA", window._fs_namespace = "FS", function (n, e, t, o, i, s, c, f) {
        t in n ? n.console && n.console.log && n.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].') : ((c = n[t] = function (n, e, t) {
          c.q ? c.q.push([ n, e, t ]) : c._api(n, e, t)
        }).q = [], (s = e.createElement(o)).async = 1, s.crossOrigin = "anonymous", s.src = "https://" + _fs_script, (f = e.getElementsByTagName(o)[0]).parentNode.insertBefore(s, f), c.identify = function (n, e, t) {
          c(i, { uid: n }, t), e && c(i, e, t)
        }, c.setUserVars = function (n, e) {
          c(i, n, e)
        }, c.event = function (n, e, t) {
          c("event", { n: n, p: e }, t)
        }, c.anonymize = function () {
          c.identify(!1)
        }, c.shutdown = function () {
          c("rec", !1)
        }, c.restart = function () {
          c("rec", !0)
        }, c.log = function (n, e) {
          c("log", [ n, e ])
        }, c.consent = function (n) {
          c("consent", !arguments.length || n)
        }, c.identifyAccount = function (n, e) {
          s = "account", (e = e || {}).acctId = n, c(s, e)
        }, c.clearUserCookie = function () {
        }, c._w = {}, f = "XMLHttpRequest", c._w[f] = n[f], f = "fetch", c._w[f] = n[f], n[f] && (n[f] = function () {
          return c._w[f].apply(this, arguments)
        }), c._v = "1.2.0")
      }(window, document, window._fs_namespace, "script", "user"), FS.identify(this.getUserInformation.email, {
        displayName: this.getUserInformation.fullName,
        email: this.getUserInformation.email,
        reviewsWritten_int: 14
      });
    },
  },

};
</script>



// WEBPACK FOOTER //
// src/App.vue